module.exports = __webpack_public_path__ + "img/background037.fded5906.jpg";